import { createFileRoute } from "@tanstack/react-router";

import { ApcMappingPage } from "@/features/apc-mapping/apc-mapping-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kartoteka/mapowanie-apc")({
	component: ApcMappingPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kartoteka.mapowanie-apc",
			location.pathname,
		);
	},
});
